import { useQuery } from 'react-query';
import { DOC_TYPE_AADE_CODE_VALUES } from '../../../interfaces/documentType.interface';
import { SORT_BY_SALES, SORT_DIRECTION } from '../../../interfaces/enumerables';
import { InvoiceInList } from '../../../interfaces/invoice.interface';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

const getSales = async (params: {
  page: number;
  orderBy: string;
  order: string;
  search?: string;
  docType?: DOC_TYPE_AADE_CODE_VALUES | 'ALL' | null;
  customerId?: string;
}): Promise<GetEntities<InvoiceInList>> => {
  await queryClient?.cancelQueries({ queryKey: ['getSales'] });

  if (params?.docType === 'ALL') {
    params.docType = null;
  }

  const resp = await apiRQ.get<GetEntities<InvoiceInList>>('/invoices', { params });

  return resp.data;
};

export const useSales = (
  page: number,
  sortBy = SORT_BY_SALES.SERIAL_NUMBER,
  order = SORT_DIRECTION.ASC,
  search: string,
  type?: DOC_TYPE_AADE_CODE_VALUES | null,
  customerId?: string,
) => {
  return useQuery<GetEntities<InvoiceInList>, Error>(
    ['getSales', page, sortBy, order, search, type, customerId],
    () => getSales({ page, orderBy: sortBy, order, search, docType: type, customerId }),
    {
      cacheTime: 200,
      staleTime: 200,
      retry: 3,
    },
  );
};
